// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Connection } from '@shared/commons/Connection';
import { Resources } from '@shared/localizations/Resources';
import { KeyCode } from '@shared/commons/KeyEventProcessor';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import TerceraTradingPasswordTemplate from '@front/templates/TerceraTradingPasswordTemplate.html';
import { BOTTOM_WINDOWS_MARGIN } from '../UtilsClasses/SizeConstants';
import { TerceraWindowBase } from './TerceraWindowBase';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import { ApplicationInfo } from '@shared/commons/ApplicationInfo';
import { DataCache } from '@shared/commons/DataCache';
import $ from 'jquery';
// constructor
export class TerceraTradingPassword extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraTradingPassword';
    }
    oncomplete() {
        super.oncomplete();
        void this.set({ allowPreviewPassword: DataCache.AllowPreviewPassword });
        this.localize();
        this.setCorrectPlace();
        this.on('UnlockClick', this.UnlockClick);
        this.Controls.tbPwd.on('keyDown', this.OnPasswordKeyDown.bind(this));
        $(window).on('resize', this.setCorrectPlace.bind(this));
    }
    setCorrectPlace() {
        const mWindow = $(window);
        const wWidth = mWindow.width();
        const wHeight = mWindow.height();
        let l = wWidth - 310 - 3;
        l = l > 0 ? l : 0;
        let t = wHeight - 190 - BOTTOM_WINDOWS_MARGIN - 5;
        t = t > 0 ? t : 0;
        void this.set({ left: l, top: t });
    }
    UnlockClick() {
        const pass = this.get('tradePass');
        if (!pass) {
            void this.set({
                visibilityError: true,
                textErrorLabel: Resources.getResource('screen.licensing.emptyFieldErrors.password')
            });
            return;
        }
        let ExternalResourse = null;
        if (ApplicationInfo.ExternalResourse !== -1) {
            ExternalResourse = ApplicationInfo.ExternalResourse;
        }
        void Connection.vendor.sendTradePassword(pass, ExternalResourse).then(function (answer) {
            if (answer) {
                void this.set({ visibilityError: false });
                TradingLockUtils.TradingLock.LockTradingByPassword = false;
                TradingLockUtils.TradingLock.updateTradingLock(false);
                this.dispose();
            }
            else {
                void this.set({
                    visibilityError: true,
                    textErrorLabel: Resources.getResource('statusBar.passwordPanel.passwordBox.invalidPass')
                });
            }
        }.bind(this));
    }
    localize() {
        void this.set({
            placeholderPassword: Resources.getResource('screen.LoginScreen.PasswordLabel'),
            textPasswordLabel: Resources.getResource('screen.UnlockTradingScreen.lockedLabel'),
            textButton: Resources.getResource('screen.UnlockTradingScreen.unlockButton'),
            textErrorLabel: Resources.getResource('statusBar.passwordPanel.passwordBox.invalidPass')
        });
    }
    OnPasswordKeyDown(e) {
        if (e.original.keyCode === KeyCode.ENTER) {
            this.UnlockClick();
        }
    }
}
TerceraWindowBase.extendWith(TerceraTradingPassword, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            width: 232,
            height: 190,
            left: 100,
            top: 100,
            movable: false,
            showFooter: false,
            resizable: false,
            focused: true,
            showFullscreenCloud: true,
            visibilityError: false,
            textButton: '',
            textPasswordLabel: '',
            textErrorLabel: '',
            allowPreviewPassword: false,
            tradePass: '',
            placeholderPassword: '',
            style_addition_body: 'tradingPassword-AdditionBody',
            style_addition_header: 'tradingPassword-AdditionHeader attach-detach-panel-header'
        };
    },
    partials: { bodyPartial: TerceraTradingPasswordTemplate }
});
